import { render, staticRenderFns } from "./OutcomeGradeSelection.vue?vue&type=template&id=0efa107a&scoped=true&"
import script from "./OutcomeGradeSelection.vue?vue&type=script&lang=js&"
export * from "./OutcomeGradeSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efa107a",
  null
  
)

export default component.exports